'use client';
import { XYCHART_HOVER_TRANSITION_MS } from './xychart-constants';
import type { XYChartLinePoint } from './xychart-types';
export interface XYChartLineHoverPointProps {
    point: XYChartLinePoint | null;
    color: string;
    seriesLabel: string;
}
export function XYChartLineHoverPoint({ point, color, seriesLabel, }: XYChartLineHoverPointProps) {
    if (!point)
        return null;
    const pointIdentity = `${seriesLabel}-${point.value}`;
    return (
    <g style={{ pointerEvents: 'none' }}>
      <circle cx={point.x} cy={point.y} r={9} fill={color} opacity={0.16}/>
      <circle cx={point.x} cy={point.y} r={4} fill="#0A0E18" stroke={color} strokeWidth={2} style={{
            transition: `cx ${XYCHART_HOVER_TRANSITION_MS}ms ease-out, cy ${XYCHART_HOVER_TRANSITION_MS}ms ease-out`,
        }}/>
    </g>
    );
}
